import React from 'react';
import { StockSymbol } from '@benzinga/session';
import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ChartParams, Sparkline } from '../../Sparkline';

interface NoteCellData {
  symbol: StockSymbol;
}

interface OwnProps {
  data: NoteCellData;
  isOnlySymbol?: boolean;
}

type Props = OwnProps & CustomCellRendererProps;

export const SparkLineCellRenderer: React.FC<Props> = params => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const renderedNods = params?.api?.getRenderedNodes();
    const targetIndex = renderedNods?.findIndex(node => node?.rowIndex === params?.node?.rowIndex);

    let showTimeout: NodeJS.Timeout | undefined = undefined;
    if (!params.data.error) {
      showTimeout = setTimeout(() => setShow(true), targetIndex + 1 * 1500);
    }
    return () => {
      clearTimeout(showTimeout);
    };
  }, [params]);

  if (params?.data?.error) {
    return '-';
  }

  return params.value && show ? (
    <Sparkline chartParams={params.colDef?.cellRendererParams} height={'compact'} omitTextInfo symbol={params.value} />
  ) : null;
};

export const SparkLineColDef = (colDef: ColDef, chartParams?: ChartParams): ColDef => ({
  cellRenderer: SparkLineCellRenderer,
  cellRendererParams: chartParams,
  filter: false,
  sortable: false,
  valueGetter: ({ data }: ValueGetterParams) => data.symbol ?? data.ticker,
  ...colDef,
});
